import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import { getRecordByShareCode } from '@/api/law';
import { getRecordByQLogId } from '@/api/ai';
import { md } from '@/utils/markdown';
export default {
  data: function data() {
    return {
      shareCode: '',
      logoUrl: "https://jh-library.oss-cn-guangzhou.aliyuncs.com/front/pc/logo.png?v=".concat(process.env['VUE_APP_V']),
      // logo图标
      footerUrl: '',
      question: '',
      answer: '',
      qrCodeBase64: '',
      alogList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    var footerUrls = ['https://jh-library.oss-cn-guangzhou.aliyuncs.com/front/wechat/share_bottom_1.png'];
    var randomIndex = Math.floor(Math.random() * footerUrls.length);
    this.footerUrl = footerUrls[randomIndex] + '?v=' + process.env['VUE_APP_V'];
    this.shareCode = this.$route.query.shareCode;
    getRecordByShareCode(this.shareCode).then(function (res) {
      _this.qrCodeBase64 = res.data.qrCodeBase64;
      getRecordByQLogId({
        qlogIds: [res.data.aiQLogId]
      }).then(function (response) {
        _this.alogList = response.data;
      });
    }).catch(function (err) {
      console.log(err);
    });
  },
  methods: {
    renderMessage: function renderMessage(message) {
      if (message.includes('###JUHUI###FAGUIJIEDU###')) {
        return '<div class="analysis-tag">法规解读</div>' + (message.split('###TITEL###')[1] || '未知标题');
      } else {
        return message;
      }
    },
    /**
     * 渲染markdown 内容
     * @param answer
     * @returns {*}
     */
    renderMarkDown: function renderMarkDown() {
      var alogList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (alogList && alogList.length > 0) {
        var lastAnswer = alogList[alogList.length - 1];
        var message = lastAnswer.answer.replaceAll('\\n', '\n');
        return md.render(message);
      } else {
        return '';
      }
    },
    tryItNow: function tryItNow() {
      window.open(process.env.VUE_APP_LAW_URL + '?ai=true', '_blank');
    }
  }
};